import { render, staticRenderFns } from "./MyStudent.vue?vue&type=template&id=5998ce49&scoped=true&"
import script from "./MyStudent.vue?vue&type=script&lang=js&"
export * from "./MyStudent.vue?vue&type=script&lang=js&"
import style0 from "./MyStudent.vue?vue&type=style&index=0&id=5998ce49&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5998ce49",
  null
  
)

export default component.exports